module.exports = __webpack_public_path__ + "static/trackcoBG-fc84a5fa74e4ed6359118bbedeb5bb59.jpg";